export const services = [
    {
        id: 'manualMassage',
        title: 'Массаж ручной',
        items: [
            {
                id: 1,
                title: 'Антицеллюлитный',
                duration: '60 мин',
                price: '5 000 ₽',
                slug: 24406701,
            },
            {
                id: 2,
                title: 'Массаж спины',
                duration: '30 мин',
                price: '3 000 ₽',
                slug: 24484455,
            },
            {
                id: 3,
                title: 'Массаж классический',
                duration: '55 мин',
                price: '4 500 ₽',
                slug: 24174750,
            },
            {
                id: 4,
                title: 'Общий Relax',
                duration: '90 мин',
                price: '6 700 ₽',
                slug: 24406797,
            },
            {
                id: 5,
                title: 'Массаж лица ручной',
                duration: '30 мин',
                price: '4 000 ₽',
                slug: 24425751,
            },
        ],
    },
    {
        id: 'bodyCorrection',
        title: 'Коррекция фигуры',
        items: [
            {
                id: 6,
                title: 'Аппаратная коррекция R - Sleek',
                duration: '60 мин',
                price: '4 800 ₽',
                slug: 24425844,
            },
            {
                id: 7,
                title: 'Аппаратная коррекция фигуры R - Sleek',
                duration: '45 мин',
                price: '4 200 ₽',
                slug: 24425874,
            },
        ],
    },
    {
        id: 'facialRejuvenation',
        title: 'Омоложение лица',
        items: [
            {
                id: 8,
                title: 'R - Sleek Face терапия с маской',
                duration: '60 мин',
                price: '4 500 ₽',
                slug: 24425904,
            },
            {
                id: 9,
                title: 'R - Sleek Face терапия',
                duration: '40 мин',
                price: '4 000 ₽',
                slug: 24425928,
            },
            {
                id: 10,
                title: 'Массаж лица ручной',
                duration: '40 мин',
                price: '4 000 ₽',
                slug: 24425967,
            },
            {
                id: 11,
                title: 'Альгинатная маска Thalasso Bretage',
                duration: '25 мин',
                price: '800 ₽',
                slug: 26563079,
            },
        ],
    },
    {
        id: 'spaPrograms',
        title: 'SPA',
        items: [
            {
                id: 12,
                title: 'SPA THALASSO BRETAGNE «Гель морские водоросли»',
                duration: '90 мин',
                price: '6 700 ₽',
                slug: 24425994,
            },
            {
                id: 13,
                title: 'Обертывание Aravia горячее',
                duration: '55 мин',
                price: '3 000 ₽',
                slug: 24426012,
            },
            {
                id: 14,
                title: 'Обертывание коррекция фигуры (холодное) Aravia',
                duration: '55 мин',
                price: '3 000 ₽',
                slug: 24426045,
            },
            {
                id: 15,
                title: 'SPA-обёртывание COMFORT ZONE',
                duration: '90 мин',
                price: '7 000 ₽',
                slug: 24426060,
            },
            {
                id: 16,
                title: 'SPA THALASSO BRETAGNE «Пелоид Геранды»',
                duration: '90 мин',
                price: '6 200 ₽',
                slug: 24426132,
            },
            {
                id: 17,
                title: 'Скрабирование тела',
                duration: '20 мин',
                price: '1 500 ₽',
                slug: 26563108,
            },
        ],
    },
    {
        id: 'browServices',
        title: 'Бровист',
        items: [
            {
                id: 18,
                title: 'Долговременная укладка бровей',
                duration: '1 ч',
                price: '1 500 ₽',
                slug: 26029770,
            },
            {
                id: 19,
                title: 'Коррекция воск - пинцет',
                duration: '30 мин',
                price: '400 ₽',
                slug: 26029794,
            },
            {
                id: 20,
                title: 'Окрашивание бровей',
                duration: '1 ч',
                price: '1 100 ₽',
                slug: 26029833,
            },
            {
                id: 21,
                title: 'Усы',
                duration: '1 ч',
                price: '300 ₽',
                slug: 26331285,
            },
        ],
    },
    {
        id: 'depilation',
        title: 'Депиляция',
        items: [
            {
                id: 22,
                title: 'Ягодицы',
                duration: '1 ч',
                price: '750 ₽',
                slug: 26331275,
            },
            {
                id: 23,
                title: 'Бикини глубокое',
                duration: '40 мин',
                price: '950 ₽',
                slug: 26331269,
            },
            {
                id: 24,
                title: 'Бикини классическое',
                duration: '30 мин',
                price: '700 ₽',
                slug: 26331263,
            },
            {
                id: 25,
                title: 'Депиляция бедра',
                duration: '25 мин',
                price: null,
                slug: 26331252,
            },
            {
                id: 26,
                title: 'Депиляция подмышечных впадин',
                duration: '30 мин',
                price: '550 ₽',
                slug: 26331239,
            },
            {
                id: 27,
                title: 'Депиляция голени + колени',
                duration: '30 мин',
                price: '900 ₽',
                slug: 26331248,
            },
            {
                id: 28,
                title: 'Депиляция ноги полностью',
                duration: '45 мин',
                price: '1 800 ₽',
                slug: 26331247,
            },
        ],
    },
    {
        id: 'solarium',
        title: 'Солярий',
        items: [
            {
                id: 29,
                title: 'Солярий',
                duration: null,
                price: '80 ₽',
                slug: 26256442,
            },
        ],
    },
    {
        id: 'laserEpilation',
        title: 'Лазерная эпиляция',
        items: [
            {
                id: 30,
                title: 'Глубокое бикини',
                duration: '15 мин',
                price: '2 800 ₽',
                slug: 27889218,
            },
            {
                id: 31,
                title: 'Классическое бикини',
                duration: '15 мин',
                price: '1 400 ₽',
                slug: 27889245,
            },
            {
                id: 32,
                title: 'Линия живота',
                duration: '5 мин',
                price: '1 100 ₽',
                slug: 27889260,
            },
            {
                id: 33,
                title: 'Живот полностью',
                duration: '15 мин',
                price: '2 800 ₽',
                slug: 27889287,
            },
            {
                id: 34,
                title: 'Поясница',
                duration: '15 мин',
                price: '1 400 ₽',
                slug: 27889305,
            },
            {
                id: 35,
                title: 'Спина полностью',
                duration: '15 мин',
                price: '3 700 ₽',
                slug: 27889323,
            },
            {
                id: 36,
                title: 'Подмышечные впадины',
                duration: '10 мин',
                price: '1 400 ₽',
                slug: 27889404,
            },
            {
                id: 37,
                title: 'Ягодицы',
                duration: '10 мин',
                price: '2 200 ₽',
                slug: 27889818,
            },
            {
                id: 38,
                title: 'Лицо полностью',
                duration: '20 мин',
                price: '2 800 ₽',
                slug: 27889848,
            },
            {
                id: 39,
                title: 'Руки от/до локтя',
                duration: '20 мин',
                price: '2 800 ₽',
                slug: 27889914,
            },
            {
                id: 40,
                title: 'Руки полностью',
                duration: '25 мин',
                price: '3 700 ₽',
                slug: 27889929,
            },
            {
                id: 41,
                title: 'Бедра',
                duration: '10 мин',
                price: '2 000 ₽',
                slug: 27889989,
            },
            {
                id: 42,
                title: 'Голени',
                duration: '10 мин',
                price: '3 700 ₽',
                slug: 27890004,
            },
            {
                id: 43,
                title: 'Ноги полностью',
                duration: '20 мин',
                price: '4 200 ₽',
                slug: 27890043,
            },
            {
                id: 44,
                title: 'Тело полностью',
                duration: '1 ч 55 мин',
                price: '10 990 ₽',
                slug: 28686120,
            },
            {
                id: 45,
                title: 'Комбо "Лайт"',
                duration: '25 мин',
                price: '3 300 ₽',
                slug: 29650224,
            },
            {
                id: 46,
                title: 'Комбо "Классический"',
                duration: '20 мин',
                price: '4 900 ₽',
                slug: 29650296,
            },
            {
                id: 47,
                title: 'Комбо "Комфорт"',
                duration: '25 мин',
                price: '4 500 ₽',
                slug: 29650344,
            },
            {
                id: 48,
                title: 'Комбо "Оптимальный"',
                duration: '25 мин',
                price: '5 800 ₽',
                slug: 29650437,
            },
            {
                id: 49,
                title: 'Комбо "Ультра"',
                duration: '30 мин',
                price: '5 200 ₽',
                slug: 29650659,
            },
            {
                id: 50,
                title: 'Комбо Стандарт',
                duration: '35 мин',
                price: '6 500 ₽',
                slug: 29848092,
            },
            {
                id: 51,
                title: 'Комбо Универсальный',
                duration: '35 мин',
                price: '6 100 ₽',
                slug: 29848104,
            },
            {
                id: 52,
                title: 'Комбо Премиум',
                duration: '45 мин',
                price: '7 300 ₽',
                slug: 29848113,
            },
            {
                id: 53,
                title: 'Комбо Стиль',
                duration: '45 мин',
                price: '6 900 ₽',
                slug: 29848128,
            },
            {
                id: 54,
                title: 'Комбо Максимум',
                duration: '1 ч',
                price: '8 700 ₽',
                slug: 29848143,
            },
        ],
    }
]
